import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, checking } = useAuth();
  const location = useLocation();

  if (checking) {
    return (
      <div
        data-testid="auth-checking"
        className="min-h-screen flex items-center justify-center font-ui text-xs tracking-eerie uppercase text-[#a89f91]"
      >
        Unlocking the cabinet…
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}
